// extracted by mini-css-extract-plugin
module.exports = {"component":"spotlight-modal-v2-component--1HePw"};